/* =====================================================================
   EISFASS PRODUKTFINDER v3.0 — individuelles Icon-Set
   Inline-SVG, 24x24 viewBox, stroke currentColor, 1.5px
   Ersetzt die Emojis aus v0.1 bis v0.3.
   Stil nach Mirkos Vorlagen: dünne Linien, runde Enden, technisch.
   ===================================================================== */

const IC = {
  /* Einstieg */
  startNeu:`<ellipse cx="10" cy="7" rx="6.5" ry="2.3" stroke-dasharray="2 2"/><path d="M3.5 7v9M16.5 7v9M3.5 16a6.5 2.3 0 0 0 13 0" stroke-dasharray="2 2"/><circle cx="19" cy="16" r="3.2"/><path d="M19 14.4v3.2M17.4 16h3.2"/>`,
  startNachruesten:`<ellipse cx="8" cy="7" rx="5.3" ry="2"/><path d="M2.7 7v9M13.3 7v9M2.7 16a5.3 2 0 0 0 10.6 0M13.3 12h2.2"/><rect x="15.5" y="9.5" width="6" height="9" rx="1.3"/><path d="M17.5 12h2M17.5 15.5h2"/>`,
  startErsetzen:`<ellipse cx="6" cy="11" rx="3.7" ry="1.5"/><path d="M2.3 11v5.5M9.7 11v5.5M2.3 16.5a3.7 1.5 0 0 0 7.4 0M12.5 7h7M17.5 4.8 20 7l-2.5 2.2M20 13h-7M15.5 10.8 13 13l2.5 2.2"/><rect x="14" y="16" width="7" height="4" rx="1.2"/>`,

  /* Nutzung */
  nutzungPrivat:`<path d="M2.5 11 12 3.5l9.5 7.5M5 9.5V21h14V9.5"/><circle cx="12" cy="11.2" r="2.1"/><path d="M8.4 18.3c.4-2.3 1.7-3.7 3.6-3.7s3.2 1.4 3.6 3.7"/>`,
  nutzungGewerb:`<circle cx="8" cy="8" r="2.5"/><circle cx="16.5" cy="8.7" r="2"/><path d="M2.5 19c0-3.2 2.4-5.5 5.5-5.5s5.5 2.3 5.5 5.5M15 13.7c3.6-.2 6 1.7 6.5 4.6"/><path d="M18.8 3.2v2.4M17.6 4.4H20"/>`,

  /* Einstiegstiefe */
  einstiegTest:`<path d="M3 3h8l10 10-8 8L3 11Z"/><circle cx="7.5" cy="7.5" r="1.5"/>`,
  einstiegRegelmaessig:`<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4M17 3v4M3 10h18m-13 5 3 3 5-5"/>`,

  /* Haltung und Platz */
  haltungSitzen:`<ellipse cx="12" cy="9" rx="7" ry="2.4"/><path d="M5 9v8M19 9v8M5 17a7 2.4 0 0 0 14 0"/><circle cx="12" cy="5" r="1.8"/><path d="M9.3 13h5.4"/>`,
  haltungLiegen:`<circle cx="6" cy="5.5" r="2"/><path d="m6.5 9 3.5 5h7.5M2 10h3m4 0h13M3 10l1.3 7a3 3 0 0 0 3 2.5h9.4a3 3 0 0 0 3-2.5l1.3-7M6 20v1M18 20v1"/>`,
  groesseKompakt:`<ellipse cx="12" cy="8" rx="5.3" ry="2"/><path d="M6.7 8v8M17.3 8v8M6.7 16a5.3 2 0 0 0 10.6 0M2.5 20h19M5.2 18.5 2.5 20l2.7 1.5M18.8 18.5l2.7 1.5-2.7 1.5"/>`,
  groesseViel:`<ellipse cx="12" cy="7" rx="7.5" ry="2.5"/><path d="M4.5 7v9M19.5 7v9M4.5 16a7.5 2.5 0 0 0 15 0M2.5 21h19M5.2 19.5 2.5 21l2.7 1.5M18.8 19.5l2.7 1.5-2.7 1.5"/>`,

  /* Bauart */
  materialAufblasbar:`<ellipse cx="10" cy="8" rx="6.5" ry="2.3"/><path d="M3.5 8v8M16.5 8v8M3.5 16a6.5 2.3 0 0 0 13 0"/><path d="M18.5 12.5h3v6h-3zM20 12.5V9.8M18.4 9.8h3.2M20 18.5v2M18.5 20.5h3"/>`,
  materialStabil:`<ellipse cx="10" cy="7" rx="6.5" ry="2.2"/><path d="M3.5 7v9M16.5 7v9M3.5 16a6.5 2.2 0 0 0 13 0M6 9v6.5M14 9v6.5"/><path d="M19 10.5 22 12v2.3c0 2-1.2 3.8-3 4.7-1.8-.9-3-2.7-3-4.7V12zM17.7 14.5l.9.9 1.8-2"/>`,

  /* Wassermenge */
  volumen250:`<ellipse cx="12" cy="7" rx="5" ry="1.8"/><path d="M7 7v9M17 7v9M7 16a5 1.8 0 0 0 10 0M8 14c1-.7 2-.7 3 0s2 .7 3 0 2-.7 3 0"/><path d="M4 20h16"/>`,
  volumen600:`<ellipse cx="12" cy="6.5" rx="6.5" ry="2.1"/><path d="M5.5 6.5v10M18.5 6.5v10M5.5 16.5a6.5 2.1 0 0 0 13 0M6.5 14c1.1-.7 2.2-.7 3.3 0s2.2.7 3.3 0 2.2-.7 3.3 0"/><path d="M3 21h18"/>`,
  volumen1000:`<ellipse cx="11" cy="5.8" rx="7.5" ry="2.3"/><path d="M3.5 5.8v12M18.5 5.8v12M3.5 17.8a7.5 2.3 0 0 0 15 0M4.5 12.5c1.3-.8 2.6-.8 3.9 0s2.6.8 3.9 0 2.6-.8 3.9 0 2.6-.8 3.9 0"/><path d="M2 22h18"/>`,
  volumenXL:`<ellipse cx="10" cy="5.8" rx="7.5" ry="2.3"/><path d="M2.5 5.8v12M17.5 5.8v12M2.5 17.8a7.5 2.3 0 0 0 15 0M3.5 11c1.3-.8 2.6-.8 3.9 0s2.6.8 3.9 0 2.6-.8 3.9 0"/><circle cx="19.5" cy="18.5" r="3"/><path d="M19.5 16.8v3.4M17.8 18.5h3.4"/>`,

  /* Beckenherkunft */
  markeEisfass:`<ellipse cx="12" cy="7" rx="7" ry="2.4"/><path d="M5 7v9.5M19 7v9.5M5 16.5a7 2.4 0 0 0 14 0"/><path d="M12 10.2s2.3 2.4 2.3 4a2.3 2.3 0 0 1-4.6 0c0-1.6 2.3-4 2.3-4Z"/>`,
  markeFremd:`<ellipse cx="10" cy="8" rx="6.5" ry="2.3"/><path d="M3.5 8v8M16.5 8v8M3.5 16a6.5 2.3 0 0 0 13 0"/><circle cx="19" cy="17" r="3"/><path d="M17.8 16a1.3 1.3 0 1 1 1.7 1.2c-.4.2-.6.5-.6.9M18.9 19.6v.05"/>`,

  /* Temperatur */
  temp8:`<rect x="5" y="3" width="4" height="12" rx="2"/><circle cx="7" cy="18" r="3"/><path d="M7 10v8M14 6h7M14 10h5"/><path d="M16 14v6M13.4 15.5l5.2 3M13.4 18.5l5.2-3"/>`,
  temp4:`<rect x="5" y="3" width="4" height="12" rx="2"/><circle cx="7" cy="18" r="3"/><path d="M7 7v11M14 5h7M14 9h7M14 13h5"/><path d="M17 15v6M14.4 16.5l5.2 3M14.4 19.5l5.2-3"/>`,
  temp2:`<rect x="4" y="4" width="4" height="11" rx="2"/><circle cx="6" cy="18" r="3"/><path d="M6 6v12M13 4v7M10 6l6 3.5M10 9.5 16 6"/><path d="M15 15c2.2 0 4 1.7 4 3.8M19 18.8l-1.8-1.7M19 18.8l1.8-1.7"/>`,

  /* Wasserpflege */
  wasserKurz:`<path d="M12 7s-3 3.6-3 6a3 3 0 0 0 6 0c0-2.4-3-6-3-6Z"/><path d="M4 8a9 9 0 0 1 15-2M19 2v4h-4M20 16a9 9 0 0 1-15 2M5 22v-4h4"/>`,
  wasserLang:`<path d="M9 3.5S4.5 8.3 4.5 12a4.5 4.5 0 0 0 9 0C13.5 8.3 9 3.5 9 3.5Z"/><path d="M16.5 5.5 21 7.4v3.2c0 3-1.8 5.5-4.5 6.7-2.7-1.2-4.5-3.7-4.5-6.7V7.4zM14.5 11l1.4 1.5 2.8-3"/>`,

  /* Winterbetrieb */
  winterDauerhaft:`<path d="M7 3v10M2.7 5.5l8.6 5M2.7 10.5l8.6-5"/><rect x="13.5" y="8" width="7" height="10" rx="1.5"/><path d="M15.5 11.5h3M17 18v3M14.5 21h5"/><path d="M4 18c1-1.8 2-1.8 3 0s2 1.8 3 0"/>`,
  winterEinlagern:`<path d="M3 9 12 3l9 6M5 8v12h14V8M9 20v-7h6v7"/><path d="M12 5.2v5M9.8 6.5l4.4 2.5M9.8 9l4.4-2.5"/>`,

  /* Standort */
  standortSonne:`<circle cx="17" cy="6" r="3"/><path d="M17 1.5v1M17 9.5v1M12.5 6h1M20.5 6h1M13.8 2.8l.7.7M19.5 8.5l.7.7M13.8 9.2l.7-.7M19.5 3.5l.7-.7"/><ellipse cx="9" cy="13" rx="5.5" ry="2"/><path d="M3.5 13v5M14.5 13v5M3.5 18a5.5 2 0 0 0 11 0"/>`,
  standortSchatten:`<path d="M2 8.5 21 5M2 8.5h19M5 8l1.5 2M10 7l1.5 2M15 6l1.5 2"/><ellipse cx="11" cy="14" rx="5.5" ry="2"/><path d="M5.5 14v4M16.5 14v4M5.5 18a5.5 2 0 0 0 11 0"/>`,
  standortIndoor:`<path d="M2.5 10.5 12 3l9.5 7.5M5 9v11h14V9"/><ellipse cx="12" cy="13" rx="4" ry="1.5"/><path d="M8 13v4M16 13v4M8 17a4 1.5 0 0 0 8 0"/>`
};
/* =====================================================================
   EISFASS PRODUKTFINDER v3.0 — Fragen und Empfehlungslogik
   Nach Mirkos Änderungsbriefing vom 25.08.2026
   ===================================================================== */

/* ---------- Becken im Finder (Bliss und Eventpool bewusst raus) ---------- */
var BECKEN = {
  easy:    {key:'easy',    name:'Eisfass Easy 2.0', liter:250, form:'sitzend',
            masse:'76 cm Ø · 65 cm hoch', art:'flexibel'},
  airmini: {key:'airmini', name:'Eisfass Air Mini', liter:300, form:'sitzend',
            masse:'90 cm Ø · 78 cm hoch', art:'flexibel'},
  air:     {key:'air',     name:'Eisfass Air',      liter:400, form:'sitzend',
            masse:'100 cm Ø · 95 cm hoch', art:'flexibel'},
  prox:    {key:'prox',    name:'Eisfass Pro X',    liter:450, form:'sitzend',
            masse:'ca. 190 × 80 × 110 cm', art:'fest'},
  eispool: {key:'eispool', name:'Eispool One',      liter:450, form:'liegend',
            masse:'155 × 65 × 62 cm', art:'fest'}
};

/* ---------- Kühlsysteme, technische Daten nach Mirkos Angaben ---------- */
var KUEHL = {
  keins:    {name:'ohne Kühlsystem', ziel:null, kaelte:null, aufnahme:null, rate:null,
             wasser:null, ozon:false, heizen:false, defroster:false},
  mini:     {key:'ks_mini',     name:'Kühlsystem Mini',     ziel:3,
             kaelte:'1.050 W', aufnahme:'ca. 450 W',   rate:'ca. 0,5–1,5 °C pro Stunde',
             wasser:'meist 3–5 Wochen', ozon:false, heizen:false, defroster:false},
  standard: {key:'ks_standard', name:'Kühlsystem Standard', ziel:3,
             kaelte:'1.400 W', aufnahme:'ca. 750 W',   rate:'ca. 1–2 °C pro Stunde',
             wasser:'meist 3–5 Wochen', ozon:false, heizen:false, defroster:false},
  pro:      {key:'ks_pro',      name:'Kühlsystem Pro 2.0',  ziel:2,
             kaelte:'ca. 3.000 W', aufnahme:'ca. 1.150 W', rate:'ca. 3–4 °C pro Stunde',
             wasser:'2 Monate oder länger', ozon:true, heizen:true, defroster:true}
};

var RATE_HINWEIS = 'Die tatsächliche Kühlgeschwindigkeit hängt unter anderem von Außentemperatur, ' +
  'Wassermenge, Standort, Isolierung und aktueller Wassertemperatur ab. Je kälter das Wasser bereits ist, ' +
  'desto langsamer kann die weitere Abkühlung erfolgen.';

/* ---------- Fragen ---------- */
var FRAGEN = {
  start: {
    q:'Wo stehst du gerade?',
    opts:[
      {v:'neu',     ic:'startNeu',          t:'Ich habe noch kein Eisbad'},
      {v:'nachrue', ic:'startNachruesten', t:'Ich habe ein Eisbad und möchte ein Kühlsystem nachrüsten'},
      {v:'ersetzen',ic:'startErsetzen',     t:'Ich möchte mein bisheriges Eisbad ersetzen'}
    ]
  },

  nutzung: {
    q:'Für wen ist das Eisbad?',
    opts:[
      {v:'privat', ic:'nutzungPrivat', t:'Für mich privat', s:'Zuhause, Familie, Freunde'},
      {v:'gewerb', ic:'nutzungGewerb', t:'Für Studio, Verein oder gewerbliche Nutzung', s:'Mehrere Nutzer täglich'}
    ]
  },

  einstieg: {
    q:'Wie ernst meinst du es schon?',
    opts:[
      {v:'test',  ic:'einstiegTest',          t:'Ich möchte günstig starten und erst einmal ausprobieren'},
      {v:'ernst', ic:'einstiegRegelmaessig', t:'Ich bade regelmäßig und will die passende Lösung'}
    ]
  },

  haltung: {
    q:'Wie möchtest du im Eisbad sitzen?',
    h:'Wähle die Form, in der du dich am wohlsten fühlst.',
    opts:[
      {v:'sitzen', ic:'haltungSitzen', t:'Aufrecht sitzen'},
      {v:'liegen', ic:'haltungLiegen', t:'Zurückgelehnt mit ausgestreckten Beinen'}
    ]
  },

  groesse: {
    q:'Wie groß darf dein Eisbad sein?',
    opts:[
      {v:'klein', ic:'groesseKompakt', t:'Wenig Stellfläche'},
      {v:'gross', ic:'groesseViel',    t:'Platz ist kein Problem'}
    ]
  },

  material: {
    q:'Wie soll es gebaut sein?',
    opts:[
      {v:'flex', ic:'materialAufblasbar', t:'Flexibel und aufblasbar', s:'Leichter, wegräumbar'},
      {v:'fest', ic:'materialStabil',     t:'Dauerhaft und maximal stabil', s:'Fester Standort'}
    ]
  },

  becken_modell: {
    q:'Welches Eisfass hast du?',
    h:'Wähle dein Modell – die passende Leistung ordnen wir zu.',
    opts:[
      {v:'easy_airmini', ic:'volumen250', t:'Easy oder Air Mini'},
      {v:'air', ic:'volumen600', t:'Eisfass Air'},
      {v:'eispool', ic:'volumen600', t:'Eispool One'},
      {v:'prox', ic:'materialStabil', t:'Eisfass Pro X'},
      {v:'event', ic:'volumen1000', t:'Eventbecken'},
      {v:'unsicher', ic:'markeFremd', t:'Ich bin unsicher'}
    ]
  },

  event_volumen: {
    q:'Wie groß ist dein Eventbecken?',
    h:'Für Eventbecken kommt ausschließlich das Kühlsystem Pro infrage. Über 1.000 Liter beraten wir dich persönlich.',
    opts:[
      {v:'bis1000', ic:'volumen1000', t:'Bis 1.000 Liter'},
      {v:'ueber1000', ic:'volumenXL', t:'Über 1.000 Liter'},
      {v:'unsicher', ic:'markeFremd', t:'Ich kenne die Größe nicht'}
    ]
  },

  volumen: {
    q:'Wie viel Wasser fasst dein Becken?',
    h:'Danach richtet sich, welches Kühlsystem die Leistung bringt.',
    opts:[
      {v:'v250',  ic:'volumen250',  t:'Bis 250 Liter'},
      {v:'v450',  ic:'volumen600',  t:'251 bis 450 Liter'},
      {v:'v451',  ic:'volumen1000', t:'Mehr als 450 Liter'},
      {v:'unsicher', ic:'markeFremd', t:'Weiß ich nicht'}
    ]
  },

  isolierung: {
    q:'Wie gut ist dein Becken isoliert?',
    h:'Eine gute Isolierung hält die Kälte im Wasser und entlastet das Kühlsystem.',
    opts:[
      {v:'gut', ic:'materialStabil', t:'Gut isoliert', s:'Isolierte Wände und isolierter Deckel'},
      {v:'schlecht', ic:'materialAufblasbar', t:'Kaum oder nicht isoliert'},
      {v:'unsicher', ic:'markeFremd', t:'Weiß ich nicht'}
    ]
  },

  becken_marke: {
    q:'Was für ein Becken hast du?',
    opts:[
      {v:'eisfass', ic:'markeEisfass', t:'Ein Eisfass von euch'},
      {v:'fremd',   ic:'markeFremd',   t:'Ein Becken einer anderen Marke oder selbst gebaut'}
    ]
  },

  temperatur: {
    q:'Wie kalt soll dein Wasser werden?',
    opts:[
      {v:'t8', ic:'temp8', t:'5–8 °C', s:'(Im Hochsommer reichen mir 5–8 °C)'},
      {v:'t4', ic:'temp4', t:'3–4 °C', s:'(Auch im Hochsommer möchte ich 3–4 °C)'},
      {v:'t2', ic:'temp2', t:'Bis 2 °C, plus Heizfunktion'}
    ]
  },

  wasserdauer: {
    q:'Wie lange möchtest du das Wasser nutzen?',
    h:'Das entscheidet mit, welche Reinigungstechnik du brauchst.',
    opts:[
      {v:'kurz', ic:'wasserKurz', t:'3–5 Wochen', s:'Wasserwechsel ist für mich in Ordnung'},
      {v:'lang', ic:'wasserLang', t:'2 Monate oder länger', s:'So wenig Wasserwechsel wie möglich'}
    ]
  },

  winter: {
    q:'Soll dein Kühlsystem auch bei Frost dauerhaft draußen angeschlossen bleiben?',
    h:'Das Becken kann draußen bleiben. Mini und Standard werden bei Frost eingelagert.',
    opts:[
      {v:'ja',   ic:'winterDauerhaft', t:'Ja, das Kühlsystem soll ganzjährig draußen bleiben', s:'Pro 2.0 mit Heiz- und Defroster-Funktion'},
      {v:'nein', ic:'winterEinlagern', t:'Nein, ich lagere das Kühlsystem bei Frost ein', s:'Das Eisbad selbst bleibt draußen nutzbar'}
    ]
  },

  standort: {
    q:'Wo soll es stehen?',
    opts:[
      {v:'sonne',  ic:'standortSonne',   t:'Viele Stunden direkte Sonne'},
      {v:'schatt', ic:'standortSchatten', t:'Überwiegend schattig'},
      {v:'indoor', ic:'standortIndoor',   t:'Drinnen oder überdacht'}
    ]
  }
};

/* ---------- Fragenpfad: nur zeigen was zählt ---------- */
function pfad(a) {
  var p = ['start'];
  if (!a.start) return p;

  if (a.start === 'nachrue') {
    p.push('becken_marke');
    if (!a.becken_marke) return p;
    if (a.becken_marke === 'eisfass') {
      p.push('becken_modell');
      if (!a.becken_modell || a.becken_modell === 'unsicher') return p;
      if (a.becken_modell === 'event') {
        p.push('event_volumen');
        return p;
      }
    } else {
      p.push('volumen');
      if (!a.volumen) return p;
      p.push('isolierung');
      if (!a.isolierung) return p;
    }
    p.push('temperatur', 'wasserdauer', 'winter', 'standort');
    return p;
  }

  /* Neukunde oder Ersatz */
  p.push('nutzung');
  if (a.nutzung === 'gewerb') return p;          /* gewerblich = feste Empfehlung */

  p.push('einstieg');
  if (a.einstieg === 'test') return p;           /* Easy 2.0 ohne Kühlung, fertig */

  p.push('haltung');
  if (a.haltung === 'liegen') {                  /* liegen führt immer zu Eispool One */
    p.push('temperatur', 'wasserdauer', 'winter', 'standort');
    return p;
  }

  p.push('groesse');
  if (a.groesse === 'gross') p.push('material'); /* Material nur wenn Air oder Pro X möglich */
  p.push('temperatur', 'wasserdauer', 'winter', 'standort');
  return p;
}

/* ---------- Becken bestimmen ---------- */
function beckenWahl(a) {
  if (a.nutzung === 'gewerb') return BECKEN.prox;
  if (a.einstieg === 'test')  return BECKEN.easy;
  if (a.haltung === 'liegen') return BECKEN.eispool;      /* ausnahmslos */
  if (a.groesse === 'klein')  return BECKEN.airmini;
  return (a.material === 'fest') ? BECKEN.prox : BECKEN.air;
}

/* ---------- Kühlsystem bestimmen ---------- */
function kuehlWahl(a, liter, gutIsoliert, istProX) {
  /* Gründe, die immer zum Pro 2.0 führen */
  if (a.nutzung === 'gewerb')     return {k: KUEHL.pro, grund: 'gewerbliche Nutzung'};
  if (a.temperatur === 't2')      return {k: KUEHL.pro, grund: 'Zieltemperatur bis 2 °C und Heizfunktion'};
  if (a.winter === 'ja')          return {k: KUEHL.pro, grund: 'ganzjähriger Betrieb draußen'};
  if (liter > 1000)               return {k: null,      grund: 'zu große Wassermenge'};
  if (liter > 600)                return {k: KUEHL.pro, grund: 'Wassermenge über 600 Liter'};
  if (a.temperatur === 't4')      return {k: KUEHL.standard, grund: 'Zieltemperatur 3 bis 4 °C'};
  if (liter > 450)                return {k: KUEHL.standard, grund: 'Wassermenge über 450 Liter'};
  if (!gutIsoliert)               return {k: KUEHL.standard, grund: 'Becken nicht oder nicht sicher gut isoliert'};
  if (istProX)                    return {k: KUEHL.standard, alternative:KUEHL.mini, grund:'optimale Leistungsreserve für das Pro X'};
  return {k: KUEHL.mini, grund:'5–8 °C im Hochsommer, gut isoliertes Becken bis 450 Liter'};
}

function literAus(v) {
  if (v === 'v250') return 250;
  if (v === 'v450') return 450;
  if (v === 'v451') return 600;
  return 0;
}

function eigenesModell(modell) {
  if (modell === 'easy_airmini' || modell === 'klein') return {liter:300, proX:false};
  if (modell === 'air') return {liter:400, proX:false};
  if (modell === 'eispool') return {liter:450, proX:false};
  if (modell === 'prox') return {liter:450, proX:true};
  if (modell === 'gross') return {liter:450, proX:false};
  return null;
}

/* ---------- Hauptempfehlung ---------- */
function empfehlen(a) {
  var log = [], hinweise = [];

  /* --- Nachrüster --- */
  if (a.start === 'nachrue') {
    if (a.becken_marke === 'eisfass') {
      if (!a.becken_modell || a.becken_modell === 'unsicher' ||
          (a.becken_modell === 'event' && a.event_volumen !== 'bis1000')) {
        return {typ:'beratung', log:log,
          titel:'Dafür brauchen wir ein persönliches Gespräch',
          text:a.becken_modell === 'event' && a.event_volumen === 'ueber1000'
            ? 'Für Eventbecken über 1.000 Liter haben wir keine verlässliche Standardlösung. Ruf uns bitte an.'
            : 'Wir klären gemeinsam dein Beckenmodell und die passende Kühlung. Ruf uns bitte an.'};
      }
      var eigen = eigenesModell(a.becken_modell);
      var modellWahl = a.becken_modell === 'event'
        ? {k:KUEHL.pro, grund:'Eventbecken bis 1.000 Liter – ausschließlich Kühlsystem Pro'}
        : kuehlWahl(a, eigen.liter, true, eigen.proX);
      log.push('nachruesten, Modellgruppe: ' + a.becken_modell);
      ergaenzeHinweise(a, modellWahl.k, hinweise);
      return {typ:'kuehlung', kuehl:modellWahl.k, alternative:modellWahl.alternative || null, grund:modellWahl.grund, becken:null, log:log, hinweise:hinweise};
    }
    var liter = literAus(a.volumen);
    log.push('nachruesten, ' + liter + ' l');

    if (a.volumen === 'unsicher') {
      return {typ:'beratung', log:log,
        titel:'Dafür brauchen wir ein persönliches Gespräch',
        text:'Ohne Wassermenge können wir die benötigte Leistung nicht zuverlässig bestimmen. ' +
             'Ruf uns bitte unter 05187 3000850 an, dann finden wir gemeinsam eine Lösung.'};
    }

    var w = kuehlWahl(a, liter, a.isolierung === 'gut', false);
    log.push('kuehlsystem: ' + w.k.name + ' (' + w.grund + ')');
    if (a.becken_marke === 'fremd') {
      hinweise.push('Für den Anschluss an ein fremdes Becken werden geeignete Zu- und Abläufe benötigt. ' +
                    'Falls du unsicher bist, ruf uns kurz an.');
    }
    ergaenzeHinweise(a, w.k, hinweise);
    return {typ:'kuehlung', kuehl:w.k, grund:w.grund, becken:null, log:log, hinweise:hinweise};
  }

  /* --- Neukunde oder Ersatz --- */
  var becken = beckenWahl(a);
  log.push('becken: ' + becken.name);

  /* Einsteiger ohne Kühlung */
  if (a.einstieg === 'test') {
    hinweise.push('Ein Kühlsystem lässt sich jederzeit nachrüsten. Für das Easy 2.0 passt später das Kühlsystem Mini.');
    return {typ:'komplett', becken:becken, kuehl:KUEHL.keins, log:log, hinweise:hinweise};
  }

  var wahl = kuehlWahl(a, becken.liter, true, becken.key === 'prox');
  if (!wahl.k) {
    return {typ:'beratung', log:log,
      titel:'Dafür brauchen wir ein persönliches Gespräch',
      text:'Für diese Wassermenge haben wir keine verlässliche Standardlösung. Ruf uns bitte unter 05187 3000850 an.'};
  }
  log.push('kuehlsystem: ' + wahl.k.name + ' (' + wahl.grund + ')');
  ergaenzeHinweise(a, wahl.k, hinweise);
  return {typ:'komplett', becken:becken, kuehl:wahl.k, alternative:wahl.alternative || null, grund:wahl.grund, log:log, hinweise:hinweise};
}

function ergaenzeHinweise(a, k, hinweise) {
  if (a.standort === 'sonne') {
    hinweise.push('Bei direkter Sonne kann sich die Kühlzeit verlängern und der Stromverbrauch steigen. ' +
                  'Ein schattiger Platz oder eine Beschattung hilft spürbar.');
  }
  if (a.winter === 'ja') {
    hinweise.push('Das Pro 2.0 verfügt über eine Heizfunktion und eine automatische Defroster-Funktion. ' +
                  'Bei dauerhaft laufender Wasserzirkulation ist der ganzjährige Betrieb im Freien möglich.');
  }
  if (a.wasserdauer === 'lang' && k && k.key !== 'ks_pro') {
    hinweise.push('Für längere Wasserstandzeiten ist eine konsequente Wasserpflege notwendig. ' +
                  'Das Pro 2.0 bietet dafür zusätzlich eine integrierte Ozonreinigung.');
  }
}

/* =====================================================================
   Oberfläche, Ergebnisdarstellung, Shopify-Anbindung, Messung
   ===================================================================== */

var CFG = window.EISFASS_FINDER || {};
var P   = CFG.produkte || {};
var OPT = CFG.optionen || {};

var TELEFON      = OPT.telefon || '05187 3000850';
var TELEFON_LINK = 'tel:' + TELEFON.replace(/[^+0-9]/g, '');
var BEWERTUNGEN  = OPT.bewertungen || 'Über 500 geprüfte Bewertungen';
var STROM_JAHR   = OPT.strom_jahr || 'ca. 150–250 €';

/* Produktdaten aus Shopify, nichts fest hinterlegt */
function prod(key)      { return P[key] || null; }
function variante(key, titel) {
  var p = prod(key); if (!p || !p.varianten || !p.varianten.length) return null;
  if (!titel) return p.varianten[0];
  for (var i = 0; i < p.varianten.length; i++) if (p.varianten[i].titel === titel) return p.varianten[i];
  return p.varianten[0];
}
function eur(n) {
  if (n === null || n === undefined) return null;
  return n.toLocaleString('de-DE', {minimumFractionDigits:0, maximumFractionDigits:0}) + ' €';
}

/* Passendes Produkt und Variante zur Empfehlung finden */
function zielProdukt(r) {
  if (r.typ === 'kuehlung') {
    return {p: prod(r.kuehl.key), v: variante(r.kuehl.key)};
  }
  var p = prod(r.becken.key);
  if (!p) return {p:null, v:null};
  var titel = null;
  if (r.kuehl && r.kuehl.name.indexOf('Mini') > -1)          titel = 'Kühlsystem mini';
  else if (r.kuehl && r.kuehl.name.indexOf('Standard') > -1) titel = 'Kühlsystem Standard';
  else if (r.kuehl && r.kuehl.name.indexOf('Pro') > -1)      titel = 'Kühlsystem Pro';
  if (!titel && p.varianten) {                     /* ohne Kühlsystem: erste Variante */
    for (var i = 0; i < p.varianten.length; i++) {
      var t = p.varianten[i].titel;
      if (/nur |^Eisfass Easy$|ohne/i.test(t)) { titel = t; break; }
    }
  }
  return {p: p, v: variante(r.becken.key, titel)};
}

/* ---------- Messung über Shopifys Customer-Events-Bus ---------- */
function veroeffentlicheShopifyEreignis(name, daten, versuch) {
  versuch = versuch || 0;
  try {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, daten);
      return;
    }
  } catch (e) {}
  /* Fängt sehr frühe Klicks ab, falls Shopifys Analytics-API noch lädt. */
  if (versuch < 40 && typeof setTimeout === 'function') {
    setTimeout(function () { veroeffentlicheShopifyEreignis(name, daten, versuch + 1); }, 100);
  }
}
function melde(ereignis, daten) {
  daten = daten || {};
  veroeffentlicheShopifyEreignis('produktfinder_' + ereignis, daten);
  try { if (window.parent !== window) window.parent.postMessage({typ:'produktfinder', ereignis:ereignis, daten:daten}, '*'); } catch (e) {}
}

/* 30-Tage-Attribution für einen späteren Kauf.
   Doppelt abgesichert: Browser-Speicher plus private Shopify-Warenkorbangabe. */
var FINDER_ATTRIBUTION_KEY = 'eisfass_produktfinder_attribution_v1';
var FINDER_CART_ATTRIBUTION_KEY = '__eisfass_produktfinder';
function merkeFinderAttribution(daten) {
  var attribution = {
    version: 1,
    zeit: Date.now(),
    empfehlung: daten.empfehlung || '',
    ziel: daten.ziel || ''
  };
  var wert = JSON.stringify(attribution);
  try { window.localStorage.setItem(FINDER_ATTRIBUTION_KEY, wert); } catch (e) {}
  try {
    if (typeof fetch !== 'function') return;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var attribute = {};
    attribute[FINDER_CART_ATTRIBUTION_KEY] = wert;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: attribute})
    }).catch(function () {});
  } catch (e) {}
}

/* ---------- Höhe an die Elternseite melden, für den iFrame-Einbau ---------- */
var letzteHoehe = 0;
function meldeHoehe() {
  try {
    if (window.parent === window) return;
    var h = Math.ceil(document.documentElement.getBoundingClientRect().height);
    if (Math.abs(h - letzteHoehe) < 2) return;
    letzteHoehe = h;
    window.parent.postMessage({typ:'produktfinder-hoehe', hoehe:h}, '*');
  } catch (e) {}
}

/* ---------- Der Finder ---------- */
function Finder(wurzel) {
  var i = 0, antworten = {}, gestartet = false, fertig = false;
  var app   = wurzel.querySelector('[data-ef-app]');
  var prog  = wurzel.querySelector('[data-ef-prog]');
  var kopf  = wurzel.querySelector('[data-ef-h1]');
  var sub   = wurzel.querySelector('[data-ef-sub]');
  var trust = wurzel.querySelector('[data-ef-trust]');
  var kopfStart = kopf ? kopf.textContent : '';
  var subStart  = sub ? sub.textContent : '';

  function svg(key) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (IC[key] || '') + '</svg>';
  }

  function nachOben() {
    try {
      if (window.parent !== window) { window.parent.postMessage({typ:'produktfinder-scroll'}, '*'); }
      // Reserve space for fixed/sticky shop navigation, including its wrappers.
      var offset = 12;
      document.querySelectorAll('header, sticky-header, .header, #header, .shopify-section-header, .shopify-section-group-header-group, [data-header]').forEach(function (el) {
        if (wurzel.contains(el)) return;
        var rect = el.getBoundingClientRect();
        var position = window.getComputedStyle(el).position;
        if ((position === 'fixed' || position === 'sticky') && rect.height > 0 && rect.height < window.innerHeight * 0.6) {
          offset = Math.max(offset, Math.max(0, parseFloat(window.getComputedStyle(el).top) || 0) + rect.height + 16);
        }
      });
      var y = wurzel.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({top: Math.max(0, y), behavior: 'smooth'});
    } catch (e) {}
  }

  function zeichne(zurueck) {
    var p = pfad(antworten);
    if (i >= p.length) return ergebnis();
    var key = p[i], f = FRAGEN[key];
    if (prog) prog.style.width = Math.round(i / (p.length + 0.4) * 100) + '%';

    app.className = 'fade';
    app.innerHTML =
      '<div class="step-n">Frage ' + (i + 1) + '</div>' +
      '<p class="q">' + f.q + '</p>' + (f.h ? '<p class="qh">' + f.h + '</p>' : '') +
      (function () {
        var btns = f.opts.map(function (o) {
          return '<button type="button" class="opt' + (antworten[key] === o.v ? ' gewaehlt' : '') +
                 '" data-v="' + o.v + '">' +
                 '<span class="ic">' + svg(o.ic) + '</span>' +
                 '<span><b>' + o.t + '</b>' + (o.s ? '<span class="s">' + o.s + '</span>' : '') + '</span></button>';
        }).join('');
        return (f.opts.length % 2 === 0 && f.opts.length <= 4)
          ? '<div class="opts-grid">' + btns + '</div>' : btns;
      })() +
      (i > 0 ? '<button type="button" class="zurueck" data-ef-back>← zurück</button>' : '');

    melde('frage_angezeigt', {
      frage: key,
      frage_nummer: i + 1,
      fragen_im_pfad: p.length
    });

    Array.prototype.forEach.call(app.querySelectorAll('.opt'), function (b) {
      b.addEventListener('click', function () {
        if (!gestartet) { gestartet = true; melde('gestartet'); }
        Array.prototype.forEach.call(app.querySelectorAll('.opt'), function (x) { x.classList.remove('gewaehlt'); });
        b.classList.add('gewaehlt');
        var alteAntwort = antworten[key];
        antworten[key] = b.dataset.v;
        melde('frage_beantwortet', {
          frage: key,
          frage_nummer: i + 1,
          antwort: b.dataset.v,
          fragen_im_pfad: pfad(antworten).length
        });
        /* Ändert sich eine frühere Antwort, verfallen die davon abhängigen */
        if (alteAntwort && alteAntwort !== b.dataset.v) {
          var neu = pfad(antworten);
          Object.keys(antworten).forEach(function (k) { if (neu.indexOf(k) === -1) delete antworten[k]; });
        }
        setTimeout(function () { i++; zeichne(); nachOben(); }, 160);
      });
    });
    var bk = app.querySelector('[data-ef-back]');
    if (bk) bk.addEventListener('click', function () { i--; zeichne(true); nachOben(); });
    void app.offsetWidth;
    meldeHoehe();
  }

  function ergebnis() {
    if (prog) prog.style.width = '100%';
    var r = empfehlen(antworten);
    if (trust) trust.style.display = 'none';
    if (!fertig) { fertig = true; melde('abgeschlossen', {empfehlung: benennung(r)}); }

    if (r.typ === 'beratung') {
      if (kopf) kopf.textContent = r.titel;
      if (sub)  sub.textContent  = 'Deine Angaben passen in keine Standardlösung.';
      app.className = 'fade';
      app.innerHTML =
        '<div class="badge">Persönliche Beratung</div>' +
        '<div class="rec"><div class="rec-in" style="padding-top:24px">' +
        '<p style="color:var(--ink-weich);margin:10px 0 0;font-size:15.5px;line-height:1.55">' + r.text + '</p>' +
        '<a class="cta" href="' + TELEFON_LINK + '" data-ef-tel>' + TELEFON + ' anrufen</a>' +
        '</div></div>' + neustartBlock();
      nachlauf(r); return;
    }

    var z = zielProdukt(r);
    var name = r.typ === 'kuehlung' ? r.kuehl.name
             : r.becken.name + (r.kuehl.ziel ? ' + ' + r.kuehl.name : '');
    var untertitel = r.typ === 'kuehlung'
      ? 'Passend zu deinem Becken'
      : (r.kuehl.ziel ? 'Komplettes Setup' : 'Einstieg ohne Kühlsystem, jederzeit nachrüstbar');

    if (kopf) kopf.textContent = 'Das passt zu dir';
    if (sub)  sub.textContent  = 'Aus deinen Antworten abgeleitet.';

    var h = '<div class="badge">Unsere Empfehlung</div><div class="rec">';
    if (z.p && z.p.bild) {
      h += '<div class="prodbild" data-ef-bild><img src="' + z.p.bild + '" alt="' + name +
           '" onerror="this.closest(\'[data-ef-bild]\').hidden=true"></div>';
    }
    h += '<div class="rec-in"' + (z.p && z.p.bild ? '' : ' style="padding-top:24px"') + '>';
    h += '<h2>' + name + '</h2>';
    h += '<p class="tag">' + untertitel + '</p>';

    if (z.v && z.v.preis != null) {
      h += '<div class="preis">' + eur(z.v.preis) + '</div>' +
           '<p class="preis-note">inkl. MwSt.</p>' +
           '<p class="raten">Ratenzahlung möglich</p>' +
           '<p class="lager ' + (z.v.verfuegbar ? 'da' : 'weg') + '">' +
           (z.v.verfuegbar ? 'Auf Lager' : 'Zurzeit nicht auf Lager') + '</p>';
    }

    h += '<div class="warum"><h4>Warum genau das</h4><ul>' +
         begruendung(antworten, r).map(function (x) { return '<li>' + x + '</li>'; }).join('') +
         '</ul></div>';

    if (r.kuehl && r.kuehl.key === 'ks_mini') {
      h += '<div class="hinweis mini-info"><b>Auch 3–4 °C sind möglich</b>' +
        '<p>Im Frühling, Herbst und an milden Sommertagen kann das Kühlsystem Mini auch 3–4 °C erreichen. ' +
        'Bei Außentemperaturen über etwa 25 °C kann die Wassertemperatur eher bei 5–8 °C liegen – abhängig von Wassermenge, Isolierung, Standort und Laufzeit.</p>' +
        '<p><strong>Unser Sommertipp:</strong> Über Nacht vorkühlen und morgens eisbaden. Durch die kühleren Nächte können auch im Hochsommer 3–4 °C möglich sein.</p></div>';
    }

    if (r.kuehl && r.kuehl.ziel) {
      h += '<div class="technik"><h4>Technische Daten</h4><dl class="ef-specs">' +
           '<div><dt>Zieltemperatur</dt><dd>je nach Bedingungen bis zu ' + r.kuehl.ziel + ' °C</dd></div>' +
           '<div><dt>Kälteleistung</dt><dd>' + r.kuehl.kaelte + '</dd></div>' +
           '<div><dt>Leistungsaufnahme</dt><dd>' + r.kuehl.aufnahme + '</dd></div>' +
           '<div><dt>Kühlrate</dt><dd>' + r.kuehl.rate + '</dd></div>' +
           '<div><dt>Wasser nutzbar</dt><dd>' + r.kuehl.wasser + '</dd></div>' +
           (r.kuehl.heizen ? '<div><dt>Heizfunktion</dt><dd>Ja</dd></div>' : '') +
           (r.kuehl.defroster ? '<div><dt>Defroster-Funktion</dt><dd>Automatisch</dd></div>' : '') +
           (r.kuehl.ozon ? '<div><dt>Wasserreinigung</dt><dd>Ozonreinigung</dd></div>' : '') +
           '<div><dt>Stromkosten pro Jahr</dt><dd>' + STROM_JAHR + '</dd></div>' +
           '</dl><small>' + RATE_HINWEIS + '<br>Die Stromkosten hängen von Außentemperatur und Zieltemperatur ab.</small></div>';
    }

    var linkZiel = z.p ? (z.p.url + (z.v ? '?variant=' + z.v.id : '')) : null;
    if (linkZiel) {
      h += '<a class="cta" href="' + linkZiel + '" target="_top" rel="noopener" data-ef-pdp>Zum Produkt</a>';
    }
    h += '</div></div>';

    if (r.hinweise && r.hinweise.length) {
      h += '<div class="hinweis"><b>Gut zu wissen</b>' +
           r.hinweise.map(function (x) { return '<p>' + x + '</p>'; }).join('') + '</div>';
    }

    if (antworten.wasserdauer === 'lang' && r.kuehl && r.kuehl.key !== 'ks_pro') {
      h += proPflegeAlternative();
    }

    if (r.alternative && r.alternative.key === 'ks_mini') {
      h += kuehlAlternativeMini();
    }

    if (antworten.einstieg === 'test' && r.becken && r.becken.key === 'easy' && !r.kuehl.ziel) {
      h += airMiniAlternative();
    }
    h += starterPack();
    h += stimmenBlock();
    h += beratungsBlock();
    h += neustartBlock();

    app.className = 'fade';
    app.innerHTML = h;
    nachlauf(r, linkZiel);
  }

  function benennung(r) {
    if (r.typ === 'beratung') return 'Beratung';
    if (r.typ === 'kuehlung') return r.kuehl.name;
    return r.becken.name + (r.kuehl.ziel ? ' + ' + r.kuehl.name : ' ohne Kühlsystem');
  }

  function airMiniAlternative() {
    var p = prod('airmini');
    if (!p || !p.url || !p.varianten) return '';
    // Never advertise a cooler bundle as the bath-only alternative.
    var v = p.varianten.find(function (x) { return /nur |ohne|^Eisfass Air Mini$/i.test(x.titel); });
    if (!v && p.varianten.length === 1 && !/kühl|kuehl|set/i.test(p.varianten[0].titel)) v = p.varianten[0];
    if (!v || v.preis == null) return '';
    var preis = v.preis.toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
    return '<div class="zusatz ef-alternative">' +
      (p.bild ? '<img src="' + p.bild + '" alt="Eisfass Air Mini" loading="lazy" onerror="this.style.display=\'none\'">' : '') +
      '<div class="txt"><h4>Lieber besser isoliert starten?</h4><p>Das Air Mini ist deine Alternative – ohne Kühlsystem starten und später bei Bedarf nachrüsten.</p>' +
      '<p><strong>' + preis + '</strong> inkl. MwSt. · ' + (v.verfuegbar ? 'Auf Lager' : 'Zurzeit nicht auf Lager') + '</p></div>' +
      '<a href="' + p.url + '?variant=' + v.id + '" target="_top" rel="noopener">Air Mini ansehen</a></div>';
  }

  function kuehlAlternativeMini() {
    var p = prod('ks_mini');
    if (!p || !p.url) return '';
    var v = variante('ks_mini');
    var preis = v && v.preis != null ? eur(v.preis) : '';
    return '<div class="zusatz ef-alternative">' +
      (p.bild ? '<img src="' + p.bild + '" alt="Kühlsystem Mini" loading="lazy" onerror="this.style.display=\'none\'">' : '') +
      '<div class="txt"><h4>Günstigere Alternative: Kühlsystem Mini</h4>' +
      '<p>Wenn dir im Hochsommer 5–8 °C reichen, kann das Mini auch am gut isolierten Pro X eingesetzt werden.</p>' +
      (preis ? '<p><strong>' + preis + '</strong> inkl. MwSt.</p>' : '') + '</div>' +
      '<a href="' + p.url + (v ? '?variant=' + v.id : '') + '" target="_top" rel="noopener">Mini ansehen</a></div>';
  }

  function proPflegeAlternative() {
    var p = prod('ks_pro');
    if (!p || !p.url) return '';
    var v = variante('ks_pro');
    return '<div class="zusatz ef-alternative">' +
      (p.bild ? '<img src="' + p.bild + '" alt="Kühlsystem Pro 2.0" loading="lazy" onerror="this.style.display=\'none\'">' : '') +
      '<div class="txt"><h4>Optional: Pro 2.0 für mehr Komfort</h4>' +
      '<p>Du möchtest das Wasser besonders lange nutzen? Das Pro 2.0 bietet zusätzlich eine integrierte Ozonreinigung. ' +
      'Für deine gewünschte Temperatur ist es aber nicht zwingend erforderlich.</p></div>' +
      '<a href="' + p.url + (v ? '?variant=' + v.id : '') + '" target="_top" rel="noopener">Pro 2.0 ansehen</a></div>';
  }

  function starterPack() {
    var s = prod('starterpack'); if (!s) return '';
    var v = variante('starterpack');
    return '<div class="zusatz">' +
      (s.bild ? '<img src="' + s.bild + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">' : '') +
      '<div class="txt"><h4>' + (OPT.starter_titel || 'Passend dazu: Starter Pack') + '</h4>' +
      '<p>' + (OPT.starter_text || 'Thermometer, Wasserpflege und der Anfänger-Guide in einem Paket.') +
      (v && v.preis != null ? ' ' + eur(v.preis) + '.' : '') + '</p></div>' +
      '<a href="' + s.url + '" target="_top" rel="noopener">Ansehen</a></div>';
  }

  function stimmenBlock() {
    var st = (CFG.stimmen && CFG.stimmen.length) ? CFG.stimmen[0] : null;
    if (!st) return '';
    return '<div class="stimme">„' + st.text + '"<cite>' + st.quelle + '</cite></div>' +
           '<p style="text-align:center;color:var(--ink-weich);font-size:13.5px;margin:0 0 14px">' +
           BEWERTUNGEN + '</p>';
  }

  function beratungsBlock() {
    return '<div class="beratung"><p>' +
      (OPT.beratung_text || 'Unsicher? Wir gehen das in fünf Minuten mit dir durch.') +
      '</p><a href="' + TELEFON_LINK + '" data-ef-tel>' + TELEFON + '</a></div>';
  }

  function neustartBlock() {
    return '<button type="button" class="zurueck" data-ef-again style="display:block;margin:0 auto">← nochmal von vorn</button>';
  }

  function nachlauf(r, linkZiel) {
    void app.offsetWidth;
    meldeHoehe();

    var pdp = app.querySelector('[data-ef-pdp]');
    if (pdp) pdp.addEventListener('click', function () {
      var klickDaten = {ziel: linkZiel, empfehlung: benennung(r)};
      merkeFinderAttribution(klickDaten);
      melde('produkt_angeklickt', klickDaten);
    });

    Array.prototype.forEach.call(app.querySelectorAll('[data-ef-tel]'), function (t) {
      t.addEventListener('click', function () { melde('anruf'); });
    });

    var again = app.querySelector('[data-ef-again]');
    if (again) again.addEventListener('click', function () {
      i = 0; antworten = {}; gestartet = false; fertig = false;
      if (kopf) kopf.textContent = kopfStart;
      if (sub)  sub.textContent  = subStart;
      if (trust) trust.style.display = '';
      zeichne(); nachOben();
    });
  }

  zeichne();
  return {reset: function () { i = 0; antworten = {}; zeichne(); }};
}

/* ---------- Begründungen, bewusst ohne absolute Aussagen ---------- */
function begruendung(a, r) {
  var o = [];
  if (a.start === 'nachrue') o.push('Du hast das Becken schon, deshalb empfehlen wir nur, was dir noch fehlt.');
  if (a.nutzung === 'gewerb') o.push('Für Studio, Verein oder gewerbliche Nutzung setzen wir auf das robusteste Becken und das stärkste Kühlsystem.');
  if (a.einstieg === 'test') o.push('Zum Ausprobieren reicht der günstige Einstieg. Ein Kühlsystem kannst du jederzeit nachrüsten.');
  if (a.haltung === 'liegen' && r.becken) o.push('Für eine zurückgelehnte Position mit ausgestreckten Beinen passt die längliche Beckenform.');
  if (a.groesse === 'klein') o.push('Wenig Stellfläche heißt kompaktes Becken.');
  if (a.material === 'fest') o.push('Für einen festen Standort und lange Nutzung ist die stabile Bauweise die passende Wahl.');
  if (a.material === 'flex') o.push('Aufblasbar heißt leichter, transportabel und bei Bedarf wegräumbar.');
  if (r.kuehl && r.kuehl.key === 'ks_mini') o.push('Das Kühlsystem Mini passt zu deinem kompakten Becken und deinem gewünschten Einsatz.');
  else if (r.grund) o.push('Beim Kühlsystem gab den Ausschlag: ' + r.grund + '.');
  if (a.winter === 'ja') o.push('Heiz- und automatische Defroster-Funktion machen das Pro 2.0 zur passenden Wahl für den ganzjährigen Betrieb.');
  return o.slice(0, 5);
}

/* ---------- Start ---------- */
function start() {
  Array.prototype.forEach.call(document.querySelectorAll('.ef[data-ef-root]'), function (el) {
    if (el.dataset.efReady) return;
    el.dataset.efReady = '1';
    Finder(el);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
document.addEventListener('shopify:section:load', start);
window.addEventListener('resize', meldeHoehe);
setInterval(meldeHoehe, 800);
